'use client'

import { createContext, type ReactNode, useContext, useMemo } from 'react'

import { Modals } from '@/components/layout/Modals'
import { type PageType } from '@/defs/page'

type PageContextType = {
  page: PageType
}
const PageContext = createContext<PageContextType | null>(null)

type Props = {
  children: ReactNode
  page: PageType
}

export const PageProvider = ({ children, page }: Props) => {
  const value = useMemo(() => ({ page }), [page])

  return (
    <PageContext.Provider value={value}>
      {children}
      <Modals />
    </PageContext.Provider>
  )
}

export const usePage = (): Partial<PageContextType> => {
  const context = useContext(PageContext)

  return { page: context?.page }
}
